// Each round shows one line-item. The player must tap the bucket it
// actually belongs in before the timer bar empties. This is the core loop
// that teaches the needs/wants/savings split used throughout the course.
export const ITEM_BANK = [
  { label: "Rent", emoji: "🏠", amount: 950, category: "NEEDS" },
  { label: "Groceries", emoji: "🛒", amount: 220, category: "NEEDS" },
  { label: "Electric Bill", emoji: "💡", amount: 90, category: "NEEDS" },
  { label: "Bus Pass", emoji: "🚌", amount: 60, category: "NEEDS" },
  { label: "Health Insurance", emoji: "🩺", amount: 140, category: "NEEDS" },
  { label: "Phone Plan", emoji: "📱", amount: 45, category: "NEEDS" },
  { label: "Prescription", emoji: "💊", amount: 25, category: "NEEDS" },
  { label: "Streaming Bundle", emoji: "📺", amount: 35, category: "WANTS" },
  { label: "New Sneakers", emoji: "👟", amount: 120, category: "WANTS" },
  { label: "Concert Tickets", emoji: "🎫", amount: 85, category: "WANTS" },
  { label: "Takeout Sushi", emoji: "🍣", amount: 40, category: "WANTS" },
  { label: "Video Game", emoji: "🎮", amount: 60, category: "WANTS" },
  { label: "Fancy Coffee Run", emoji: "☕", amount: 18, category: "WANTS" },
  { label: "Arcade Skin Pack", emoji: "🕹️", amount: 15, category: "WANTS" },
  { label: "Emergency Fund", emoji: "🧯", amount: 100, category: "SAVINGS" },
  { label: "Index Fund Buy", emoji: "📈", amount: 150, category: "SAVINGS" },
  { label: "Roth IRA", emoji: "🏦", amount: 200, category: "SAVINGS" },
  { label: "High-Yield Savings", emoji: "💰", amount: 75, category: "SAVINGS" },
  { label: "Sinking Fund: Car", emoji: "🚗", amount: 90, category: "SAVINGS" },
  { label: "Sinking Fund: Trip", emoji: "✈️", amount: 60, category: "SAVINGS" },
];

export const BUCKETS = [
  { id: "NEEDS", label: "Needs", hint: "Can't skip it", accent: "cyan" },
  { id: "WANTS", label: "Wants", hint: "Nice, not necessary", accent: "magenta" },
  { id: "SAVINGS", label: "Savings", hint: "Pay future you", accent: "gold" },
];

export const STARTING_LIVES = 3;
export const ITEMS_PER_LEVEL = 8;
export const BASE_TIME_MS = 4200;
export const MIN_TIME_MS = 1600;
export const TIME_STEP_PER_LEVEL = 260;

export function pickItem(lastLabel) {
  let next = ITEM_BANK[Math.floor(Math.random() * ITEM_BANK.length)];
  // Avoid immediate repeats so it doesn't feel stale.
  let guard = 0;
  while (next.label === lastLabel && guard < 6) {
    next = ITEM_BANK[Math.floor(Math.random() * ITEM_BANK.length)];
    guard += 1;
  }
  return next;
}

export function timeLimitForLevel(lvl) {
  return Math.max(MIN_TIME_MS, BASE_TIME_MS - (lvl - 1) * TIME_STEP_PER_LEVEL);
}

export function computeGain(amount, combo) {
  const comboMultiplier = 1 + combo * 0.25;
  return Math.max(1, Math.round(amount * 0.5 * comboMultiplier));
}
